import { JSX, ReactNode } from 'react'

import { For } from '@chakra-ui/react'
// eslint-disable-next-line no-duplicate-imports
import { Grid, VStack, Span, Separator, Fieldset, FieldsetRootProps } from '@chakra-ui/react'




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Root
(
	props: {
		name: string

		divide?  : boolean
		children?: ReactNode

	},

)
:	JSX.Element
{
	let pt = 0

	if (props.divide === true)
	{
		pt = 24

	}

	return (
		<Fieldset.Root>
			<Fieldset.Legend fontSize="xl" pt={pt}>{props.name}</Fieldset.Legend>

			<Serif />

			<Grid gap="6">{props.children}</Grid>
		</Fieldset.Root>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Label
(
	props: {
		name: string
		text: number | string

	},

)
:	JSX.Element
{
	return (
		<VStack gap="1.5" w="full" align="start">
			<Span
				color="fg.subtle"
				fontSize="md"
				fontWeight="medium"
				lineHeight="shorter"
				children={props.name}
			/>

			<Span
				color="fg"
				fontSize="xl"
				lineHeight="moderate"
				children={props.text}
			/>

		</VStack>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function List
(
	props: FieldsetRootProps
			& {
				name: string
				data: Array<[string, unknown]>

			},

)
:	JSX.Element
{
	return (
		<Fieldset.Root {...props}>
			<Fieldset.Legend fontSize="xl">{props.name}</Fieldset.Legend>

			<VStack gap="6">
				<For each={props.data}>
					{([label, value], index) => <Label key={`${index}.${label}`} name={label} text={String(value)} /> }

				</For>

			</VStack>

		</Fieldset.Root>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Serif (): JSX.Element
{
	return (
		<Separator size="xs" variant="dashed" />

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Group
(
	props: {
		columns? : number[]
		children?: ReactNode

	},

)
:	JSX.Element
{
	let columns = props.columns ?? [1, 1, 1, 1]

	return (
		<Grid gap="6" templateColumns={columns.map(v => `${v}fr`).join(' ')}>
			{props.children}

		</Grid>

	)

}
